import { supabase } from "./supabase";

const TENANT_DOMAIN = "ikone.rs";

async function getTenantId() {
  const { data, error } = await supabase
    .from("tenants")
    .select("id")
    .eq("domain", TENANT_DOMAIN)
    .single();
  if (error) throw error;
  return data.id;
}

export async function getProducts(categorySlug = null) {
  const tenantId = await getTenantId();

  let query = supabase
    .from("products")
    .select(`
      id, slug, name, description, price,
      kolicina_na_stanju, images, attributes,
      categories ( id, name, slug )
    `)
    .eq("tenant_id", tenantId)
    .eq("is_active", true)
    .order("created_at", { ascending: false });

  if (categorySlug) {
    const { data: cat } = await supabase
      .from("categories")
      .select("id")
      .eq("tenant_id", tenantId)
      .eq("slug", categorySlug)
      .single();
    if (cat) query = query.eq("category_id", cat.id);
  }

  const { data, error } = await query;
  if (error) throw error;
  return data;
}

export async function getProductBySlug(slug) {
  const tenantId = await getTenantId();

  const { data, error } = await supabase
    .from("products")
    .select(`
      id, slug, name, description, price,
      kolicina_na_stanju, images, attributes,
      categories ( id, name, slug )
    `)
    .eq("tenant_id", tenantId)
    .eq("slug", slug)
    .eq("is_active", true)
    .single();

  if (error) throw error;
  return data;
}

export async function getCategories() {
  const tenantId = await getTenantId();

  const { data, error } = await supabase
    .from("categories")
    .select("id, name, slug, parent_id")
    .eq("tenant_id", tenantId)
    .order("name");

  if (error) throw error;
  return data;
}
